import React, { Component } from "react";
import {
  Typography,
  Box,
  IconButton,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Alert,
  CardActionArea,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ShareIcon from "@mui/icons-material/Share";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useParams, useNavigate } from "react-router-dom";
import Serverurl from "./Apiurl";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import axios from 'axios';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EmailIcon from "@mui/icons-material/Email";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";


class PurchaseView extends Component {
	constructor(props) {
    super(props);

    this.state = {
        statusAnchor: null,
        status: "Status",
		  emailDialogOpen: false,
emailAddress: ""
    };
}

handleEdit = () => {

    const id = window.location.pathname.split("/").pop();

    this.props.navigate(
        "/Makepurchase?edit=" + id
    );

};
openEmailDialog = () => {
  this.setState({ emailDialogOpen: true, emailAddress: "" });
};

closeEmailDialog = () => {
  this.setState({ emailDialogOpen: false });
};

handleEmail = async () => {
 const emails = this.state.emailAddress ? this.state.emailAddress.trim() : "";
    const id = this.props.id;
if (!emails) { alert("Please enter email address."); return; }
const emailList = emails.split(",").map((email) => email.trim()).filter((email) => email);
const invalidEmail = emailList.find((email) => !/^[^\s@]+@[^\s@]+.[^\s@]+$/.test(email));
if (invalidEmail) { alert("Invalid email address: " + invalidEmail); return; }
const formdata = new FormData();
formdata.append("action", "sendemailop");
formdata.append("qu_id", id);
formdata.append("emails", emailList.join(","));
formdata.append("qu_type", 2);
try {
const response = await axios.post(Serverurl + "ajaxquotation.php", formdata);
console.log("EMAIL RESPONSE:", response.data);
if (response.data.status === "success") { alert("Purchase Order sent successfully."); this.closeEmailDialog(); } else { alert(response.data.message || "Email sending failed."); }
} catch (error) {
console.error("EMAIL ERROR:", error);
console.error("SERVER RESPONSE:", error.response?.data);
alert("Email sending failed.");
}
};

    handleShare = async () => {
        const id = this.props.id;
        const pdfUrl = Serverurl + "uploads/Purchase_order-" + id + ".pdf";

this.setState({ isSharing: true });

try {
    if (navigator.share) {
        await navigator.share({
            title: "Purchase Order #" + id,
            text: "Here is the Purchase Order PDF document.",
            url: pdfUrl
        });
    } else {
        await navigator.clipboard.writeText(pdfUrl);
        alert("PDF link copied to clipboard.");
    }
} catch (error) {
    if (error.name !== "AbortError") {
        console.error("Share error:", error);
        await navigator.clipboard.writeText(pdfUrl);
        alert("PDF link copied to clipboard.");
    }
} finally {
    this.setState({ isSharing: false });
}
    };
	
	
handleWhatsApp = async () => {
	let r = window.confirm("Please confirm to send on Whatsapp?");

    if (r === true) {
    const formData = new FormData();

    formData.append("action", "sendwhatsapp");
    formData.append("qu_id", this.props.id);
    formData.append("bu_id", localStorage.getItem("GBuserid"));
        formData.append("bu_name", localStorage.getItem("GBname"));
	formData.append("qu_type", 2);

    try {
        const response = await axios.post(
            Serverurl + "ajaxquotation.php",
            formData
        );

        console.log(
            "PURCHASE WHATSAPP RESPONSE:",
            response.data
        );

        if (response.data.status === "success") {
            alert(
                "Purchase Order sent successfully on WhatsApp."
            );
        }
			else {
            alert(
                response.data.message ||
                "WhatsApp sending failed."
            );
        }
}
    
	catch (error) {

        console.error(
            "PURCHASE WHATSAPP ERROR:",
            error
        );

        console.error(
            "SERVER RESPONSE:",
            error.response?.data
        );

        alert(
            error.response?.data?.message ||
            "WhatsApp sending failed."
        );
    }
	} 
};



handleStatusClick = (event) => {
    this.setState({
        statusAnchor: event.currentTarget
    });
};


handleStatusClose = () => {
    this.setState({
        statusAnchor: null
    });
};


handleStatusChange = (status) => {

    const id = window.location.pathname.split("/").pop();

    let r = window.confirm("Do you really want to update the status?");

    if (r === true) {

        this.setState({
            status: status,
            statusAnchor: null
        });

        const formData = new FormData();

        formData.append("qu_id[]", id);
        formData.append("qu_status", status);
        formData.append("action", "quotationstatus");

        axios.post(Serverurl + "ajaxquotation.php", formData)
            .then((res) => {

                if (String(res.data).trim() === "1") {
                    alert("Status Updated");
                } else {
                    alert("Status Update Failed");
                }

            })
            .catch((error) => {

                alert("Status Update Failed");

            });

    } else {

        // Cancel - close menu only, don't change status
        this.setState({
            statusAnchor: null
        });

    }
};

handleDuplicate = () => {

    const id = window.location.pathname.split("/").pop();

    this.props.navigate(
        "/Makepurchase?duplicate=" + id
    );

};
isStatusFinal = () => {
  return (
    this.state.status === "Approved" ||
    this.state.status === "Rejected"
  );
};

    render() {

        const id = this.props.id;

    const params = new URLSearchParams(window.location.search);
    const source = params.get("source");

    let pdfUrl;

    if (source === "purchaseorder") {
        pdfUrl =
            Serverurl +
            "uploads/Purchase_order-" +
            id +
            ".pdf";
    } else {
        pdfUrl =
            Serverurl +
            "makepurchasepdf.php?qu_id=" +
            id;
    }

    return (
        <>

           <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>

	<Dialog open={this.state.emailDialogOpen} onClose={this.closeEmailDialog} maxWidth="sm" fullWidth>
  <DialogTitle>Send Email</DialogTitle>
  <DialogContent>
    <TextField label="Email Address" type="email" value={this.state.emailAddress} onChange={(e) => this.setState({ emailAddress: e.target.value })} fullWidth margin="normal" />
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
      <Button variant="contained" sx={{ bgcolor: '#103f86 !important' }} onClick={this.closeEmailDialog}>Cancel</Button>
      <Button variant="contained" sx={{ bgcolor: '#103f86 !important' }} onClick={this.handleEmail}>Send</Button>
    </Box>
  </DialogContent>
</Dialog>
<Box 
    sx={{
        height:"100vh",
        position:"relative"
    }}
>

    


    <iframe
    title="Purchase PDF"
    src={pdfUrl}
    style={{
        width: "100%",
        height: "calc(100% - 120px)",
        border: "none"
    }}
/>


    {/* Bottom Action Bar */}
<div className="sharingbuttons">
    <Box
        sx={{
            position:"fixed",
            bottom:0,
            left:0,
            right:0,
            background:"#f0f4f7",
            display:"flex",
            justifyContent:"center",
			flexWrap: "wrap",
            gap:2,
            p:2,
            boxShadow:"0 -2px 8px rgba(0,0,0,0.15)"
        }}
    >

        <Button
            variant="contained"
            onClick={this.handleEdit}
			 sx={{ bgcolor: '#103f86' }}
        >
            <EditIcon />
        </Button>


        <Button
            variant="contained"
    
            onClick={this.handleDuplicate}
			 sx={{ bgcolor: '#103f86' }}
        >
            <ContentCopyIcon />
        </Button>


        <Button
            variant="contained"
          
            onClick={this.handleShare}
			 sx={{ bgcolor: '#103f86' }}
        >
            <ShareIcon />
        </Button>
		
		
		<Button
    variant="contained"
    onClick={this.handleWhatsApp}
    sx={{ bgcolor: '#103f86' }}
>
    <WhatsAppIcon />
</Button>

<Button variant="contained"
            color="primary" onClick={this.openEmailDialog}  sx={{ bgcolor: '#103f86' }}>
  <EmailIcon />
  </Button>
       <Button
  variant="contained"
  color={
    this.state.status === "Approved"
      ? "success"
      : this.state.status === "Rejected"
      ? "error"
      : "warning"
  }
  startIcon={<CheckCircleIcon />}
  onClick={this.handleStatusClick}
  disabled={this.isStatusFinal()}
   sx={{ bgcolor: '#103f86' }}
>
  {this.state.status}
</Button>



        <Menu
            anchorEl={this.state.statusAnchor}
            open={Boolean(this.state.statusAnchor)}
            onClose={this.handleStatusClose}
        >

            <MenuItem
                onClick={() =>
                    this.handleStatusChange("Inprogress")
                }
            >
                Inprogress
            </MenuItem>


            <MenuItem
                onClick={() =>
                    this.handleStatusChange("Approved")
                }
            >
                Approved
            </MenuItem>


            <MenuItem
                onClick={() =>
                    this.handleStatusChange("Rejected")
                }
            >
                Rejected
            </MenuItem>

        </Menu>


    </Box>
</div>

</Box>

</>
);

    }

}


function PurchaseViewWrapper(){

    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <PurchaseView
            id={id}
            navigate={navigate}
        />
    );

}


export default PurchaseViewWrapper;